<template>
   <div>
    <div v-if="index==1">
      <el-dialog :close-on-click-modal="false"
      title="菜品授权"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      center
    >
    <div class="content">
        <div class="contentQp">
        <div class="qpLeft">
          <div v-for="(item,index) in notEmpow" :key='index' class="empow">
            <el-checkbox v-model="item.checked"  @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.name }}</span>
          </div>
        </div>
        <div class="qpCenter">
          <div class="qpCenter_input">
            <span>日库存</span>
            <el-input placeholder="数量" v-model="nums"></el-input>
          </div>
          <div class="qpCenter_btns">
             <div @click="select">选择</div>
             <div @click="qbselect">全部选择</div>
          </div>
          <!-- <div class="qpCenter_cancellation">
             <div>选择</div>
             <div>全部选择</div>
          </div> -->
        </div>
        <div class="qpRight">
          <div v-for="(item,index) in empower" :key="index" class="empow" >
            <el-checkbox v-model="item.checked"   @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.name }}</span>
          </div>
        </div>
        </div>
        <div class="contentBtns">
            <!-- <div>重置</div> -->
            <div @click="caiBtns">确认授权</div>
        </div>
      </div>
      </el-dialog>
    </div>
    <!-- <div v-if="index==2">
      <el-dialog :close-on-click-modal="false"
      title="菜品授权"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      center
    >
      <div class="content">
        <div class="contentQp">
        <div class="qpLeft">
          <div v-for="(item,index) in notEmpow" :key='index' class="empow">
            <el-checkbox v-model="item.checked"  @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.name }}</span>
          </div>
        </div>
        <div class="qpCenter">
          <div class="qpCenter_input">
            <span>日库存</span>
            <el-input placeholder="数量"></el-input>
          </div>
          <div class="qpCenter_btns">
             <div>选择</div>
             <div>全部选择</div>
          </div>
          <div class="qpCenter_cancellation">
             <div>选择</div>
             <div>全部选择</div>
          </div>
        </div>
        <div class="qpRight">
          <div v-for="(item,index) in empower" :key="index" class="empow" >
            <el-checkbox v-model="item.checked"   @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.name }}</span>
          </div>
        </div>
        </div>
        <div class="contentBtns">
            <div>重置</div>
            <div>确认授权</div>
        </div>
      </div>
    </el-dialog>
    </div> -->
   </div>
</template>
<script>
import {MenuGranted,MenuSQ} from '@/request/scenic.js'
import { Message } from 'element-ui'
export default {
  data(){
    return{
      nums:'',
      addProDialogVisible:false,
      index:'1',
      notEmpow:[
      ],
        empower:[
        ],
        rid:'',
        mid:'',
        num:''
    }
  },
  created(){
  },
  methods:{
    caiBtns(){
      this.empower.map(item=>{
        if(item.checked==false){
          this.mid += item.id + ','
          this.num += item.num + ','
        }
      })
      if (this.mid.length > 0) {
        this.mid  = this.mid.substr(0,this.mid.length - 1);
      }
      if (this.num.length > 0) {
        this.num  = this.num.substr(0,this.num.length - 1);
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        rid:this.rid,
        mid:this.mid,
        num:this.num
      }
      MenuSQ(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('授权成功')
          this.addProDialogVisible = false
          this.$emit('Close')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    select(){
      if(this.nums){
        this.notEmpow.map(item=>{
          if(item.checked){
            this.num += this.nums + ','
            this.mid += item.id + ','
            this.empower.push(item)
          }
        })
        for(let i=this.notEmpow.length-1;i>=0;i--){
          if(this.notEmpow[i].checked){
            this.notEmpow.splice(i, 1);
          }
        }
      }else{
        this.notEmpow.map(item=>{
          if(item.checked){
            this.num += item.num + ','
            this.mid += item.id + ','
            this.empower.push(item)
          }
        })
        for(let i=this.notEmpow.length-1;i>=0;i--){
          if(this.notEmpow[i].checked){
            this.notEmpow.splice(i, 1);
          }
        }
      }
    },
    qbselect(){
      if(this.nums){
        this.notEmpow.map(item=>{
            this.num += this.nums + ','
            this.mid += item.id + ','
            item.checked = true
            this.empower.push(item)
        })
        for(let i=this.notEmpow.length-1;i>=0;i--){
              this.notEmpow.splice(i, 1);
        }
      }else{
        this.notEmpow.map(item=>{
            this.num += item.num + ','
            this.mid += item.id + ','
            item.checked = true
            this.empower.push(item)
        })
        for(let i=this.notEmpow.length-1;i>=0;i--){
              this.notEmpow.splice(i, 1);
        }
      }
    },
    getList(row){
      this.rid = row.id
      let data = {
        token:window.sessionStorage.getItem('Token'),
        rid:row.id
      }
      MenuGranted(data).then(res=>{
        if(res.data.status=='ok'){
          this.notEmpow = res.data.result.menuLists
          this.notEmpow.map(item=>{
            item.checked = false
          })
          this.empower = res.data.result.sqMenu
          this.empower.map(item=>{
            item.checked = false
          })
        }
      })
    },
    pxFn(row){
      this.index = row.index
      this.getList(row.data)
      this.addProDialogVisible = true
    },
    addProHandleClose(){
      this.addProDialogVisible = false
      this.$emit('Close')
    }
  }
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__body{
  padding: 2rem 0 !important;
  border-top: 1px solid #E5E5EA;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
      background: #246DEB;
    }
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40rem;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    span{
      color: #666;
    }
    >div{
      margin-bottom: 1.8rem;
    }
  }
  .qpRight {
    width: 40rem;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    > div{
      font-style: normal;
      font-weight: 400;
      margin-bottom: 1.8rem;
      // color: #e74c3c;
      color: #666666;
      font-size: 1.4rem;
      span {
        margin-right: 10px;
        color: #666;
      }
    }
    
  }
}
.qpCenter{
  margin: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .qpCenter_input{
    display: flex;
    flex-direction: column;
    span{
      color: #666;
      font-size: 1.4rem;
    }
    ::v-deep.el-input{
      margin-top: 1rem;
      width: 14rem;
    }
  }
  .qpCenter_btns{
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    >div{
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #246DEB;
      width: 14rem;
      height: 4rem;
      line-height: 4rem;
      color: #246DEB;
      margin-bottom: 2rem;
    }
  }
  .qpCenter_cancellation{
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    >div{
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #E74C3C;
      width: 14rem;
      height: 4rem;
      line-height: 4rem;
      color: #E74C3C;
      margin-bottom: 2rem;
    }
  }
}
</style>